/* eslint-disable @typescript-eslint/camelcase */
import { number, object, string } from 'yup';

export default object({
  id: string(),
  task_name: string(),
  task_version: number(),
  description: string().nullable(),
});
